export default () => ({
  data: [],
  meta: {},
  isLoading: false,
  hasError: false,
});
